/**
 * Development logging utility
 * Logs are only output in development mode
 */
const isDevelopment = process.env.NODE_ENV === 'development';
export const logger = {
    log: (...args) => {
        if (isDevelopment) {
            console.log(...args);
        }
    },
    warn: (...args) => {
        if (isDevelopment) {
            console.warn(...args);
        }
    },
    error: (...args) => {
        // Always log errors, even in production
        console.error(...args);
    },
};
